import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getNetworkDeviceContentById = (networkDeviceId) => {
    return axios.get(`/api/networkDevicesContent/${networkDeviceId}`, {headers: authHeader()})
        .then(res => {
            return res.data
        });
};

const getNetworkDeviceContentByContentId = (contentId) => {
    return axios.get(`/api/networkdevicescontent/getById/${contentId}`, {headers: authHeader()})
        .then(res => {
            return res.data
        });
};

const getDefaultApplication = () => {
    return axios.get(`/api/networkdevicescontent/getdefaultapps`, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const getLauncherDropdown = (networkDeviceId) => {
    return axios.get(`/api/networkdevicescontent/GetLauncherDropdown/${networkDeviceId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const setDefaultContent = (networkDeviceId, value) => {
    return axios.patch(`/api/networkdevicescontent/setisdefault/${ networkDeviceId }/${ value }`, {}, { headers: authHeader()})
        .then(res => {
            return res.data
        })
};

const fileUpload = (formData, progressEvent) => {
    const headers = Object.assign(authHeader(), {
        "Enctype": 'multipart/form-data',
        // "Content-Disposition": "form-data"
    });

    return axios.post(`/api/networkDevicesContent/uploadFile`, formData, {
        headers: headers,
        onUploadProgress: progressEvent
    })
        .then(res => {
            return res.data
        });
};

const addNetworkDeviceContent = (createModel) => {
    return axios.post(`/api/networkDevicesContent/${createModel.sessionId}`, createModel, {headers: authHeader()})
        .then(res => {
            return res.data
        });
};

const editNetworkDeviceContent = (updateModel) => {
    return axios.patch(`/api/networkDevicesContent/${updateModel.id}/${updateModel.sessionId}`, updateModel, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};

const deleteNetworkDeviceContent = (deleteId) => {
    return axios.delete(`/api/networkDevicesContent/${deleteId}`, {headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const retryNetworkDeviceContent = (contentId) => {
    return axios.patch(`/api/networkdevicescontent/retry/${contentId}`, {}, {headers: authHeader()})
        .then(res => {
            return res.data
        })
};

const copyNetworkDeviceContent = (copyModel) => {
    return axios.post(`/api/NetworkDevicesContent/MakeCopy/${copyModel.contentId}/${copyModel.exhibitionScenarioId}`,{ }, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

const deleteActivityLogs = (networkDeviceId, dates) => {
    return axios.delete(`/api/logs/DeleteContentActivity/${networkDeviceId}/${dates}`, {headers: authHeader()})
        .then(res => {
            return res.data
        })
}

export const networkDeviceContentService = {
    getNetworkDeviceContentById,
    getNetworkDeviceContentByContentId,
    getDefaultApplication,
    getLauncherDropdown,
    setDefaultContent,
    fileUpload,
    addNetworkDeviceContent,
    editNetworkDeviceContent,
    deleteNetworkDeviceContent,
    retryNetworkDeviceContent,
    copyNetworkDeviceContent,
    deleteActivityLogs
};
